import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://lygnfnlswhklapuygsox.supabase.co'  // Supabase URL
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx5Z25mbmxzd2hrbGFwdXlnc294Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA2NjQxMTcsImV4cCI6MjA1NjI0MDExN30.N2AV9_-R1hOr4BCh2LR0U9RpEhw1Qn45S-WKm1KaF18'  // Supabase 匿名密钥

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)